import { IOneStoreConciliation } from "@/@types/store-conciliation";
import CashIcon from "@/assets/icons/cash-icon";
import { numberToCurrency } from "@/utils/money";
import { RefreshCw } from "lucide-react";
import { memo } from "react";
import { ActionButtons } from "../action-buttons";
import { ProcessingInfo } from "../processing-info";

interface CardHeaderContentProps {
    conciliation: IOneStoreConciliation | undefined;
    processingDate: string;
    totalAmount: number;
    actions: Array<{
        label: string;
        onclick: () => void;
    }>;
    isClosed: boolean;
    isAdmin: boolean;
    isLoading: boolean;
    isFetching?: boolean;
    isSaveLoading: boolean;
    onAddDivergence: () => void;
    onSaveAll: () => void;
    onRefresh?: () => void;
    conciliation_id?: string;
}

function CardHeaderContentInner({
    conciliation,
    processingDate,
    totalAmount,
    actions,
    isClosed,
    isAdmin,
    isLoading,
    isFetching,
    isSaveLoading,
    onAddDivergence,
    onSaveAll,
    onRefresh,
    conciliation_id,
}: CardHeaderContentProps) {
    return (
        <div className="space-y-3">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <div className="space-y-2">
                    <div className="flex items-center justify-start gap-3 text-[#2B0C1A] font-bold text-sm">
                        <CashIcon color="#2B0C1A" size={16} />
                        Lista de Divergências
                        {onRefresh && (
                            <button
                                onClick={onRefresh}
                                disabled={isFetching}
                                className="p-1 rounded-md text-gray-400 hover:text-[#2B0C1A] hover:bg-gray-100 transition-all disabled:opacity-50"
                                title="Atualizar dados"
                            >
                                <RefreshCw className={`h-3.5 w-3.5 ${isFetching ? "animate-spin" : ""}`} />
                            </button>
                        )}
                    </div>
                    <ProcessingInfo
                        conciliation={conciliation}
                        processingDate={processingDate}
                    />
                </div>
                <div className="text-sm">
                    <span className="font-bold text-[#2B0C1A]">
                        Total Divergências conciliadas -{" "}
                    </span>
                    {numberToCurrency(totalAmount)}
                </div>
            </div>
                <ActionButtons
                    actions={actions}
                    isClosed={isClosed}
                    isAdmin={isAdmin}
                    isLoading={isLoading}
                    isSaveLoading={isSaveLoading}
                    onAddDivergence={onAddDivergence}
                    onSaveAll={onSaveAll}
                    conciliation_id={conciliation_id}
                />
        </div>
    );
}

export const CardHeaderContent = memo(CardHeaderContentInner);
